<template>
  <div class="">
    <div class="w-full text-center">
      <div class="flex justify-center items-center border-b-2 pt-8 pb-1">
        <skeleton width="60%" height="1.5rem" rounded />
      </div>
      <div class="flex justify-center items-center pt-3 pb-1">
        <skeleton width="10%" height="1rem" rounded />
      </div>
    </div>

    <div class="mt-2 grid grid-cols-3 gap-8 rounded-xl">
      <div class="w-full overflow-hidden rounded-xl border-2 border-gray-300">
        <div
          class="flex h-16 items-center justify-between p-2 py-2 pr-4 pl-6 shadow"
        >
          <div class="flex w-full items-center">
            <div class="block w-4/5">
              <skeleton width="100%" height="1.25rem" rounded />
            </div>
          </div>
          <div class="flex">
            <div>
              <skeleton width="1.5rem" height="1.5rem" type="circle" />
            </div>
          </div>
        </div>
      </div>
      <div class="w-full overflow-hidden rounded-xl border-2 border-gray-300">
        <div
          class="flex h-16 items-center justify-between p-2 py-2 pr-4 pl-6 shadow"
        >
          <div class="flex w-full items-center">
            <div class="block w-4/5">
              <skeleton width="100%" height="1.25rem" rounded />
            </div>
          </div>
          <div class="flex">
            <div>
              <skeleton
                width="1.5rem"
                height="1.5rem"
                radius="50%"
                type="circle"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="w-full overflow-hidden rounded-xl border-2 border-gray-300">
        <div
          class="flex h-16 items-center justify-between p-2 py-2 pr-4 pl-6 shadow"
        >
          <div class="flex w-full items-center">
            <div class="block w-4/5">
              <!-- <div
                class="h-5 w-full rounded-md bg-gray-300 font-semibold"
              ></div> -->
              <skeleton width="100%" height="1.25rem" rounded />
            </div>
          </div>
          <div class="flex">
            <div>
              <!-- <div
                class="border-1 flex h-6 w-6 items-center justify-center rounded-full bg-gray-300 p-1"
              ></div> -->
              <skeleton width="1.5rem" height="1.5rem" type="circle" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from "skeleton-loader-vue";
export default {
  components: {
    Skeleton,
  },
};
</script>

<style></style>
